export default {
      id: "masqueimg-usage",
      viewBox: "0 0 458 639",
      url: "../dist/images/" + "sprite.svg#masqueimg-usage",
      toString: function () {
        return this.url;
      }
    }